(() => {
  'use strict';
  const films = {"day":{"desktop":"https://cdn.shopify.com/videos/c/o/v/ee5a55e332d84844bedc8503396b7a23.mp4","mobile":"https://cdn.shopify.com/videos/c/o/v/ee5a55e332d84844bedc8503396b7a23.mp4","poster":"https://cdn.shopify.com/s/files/1/0844/7672/3453/files/vclot-campana-corregida-day-poster.jpg?v=1793141371"},"night":{"desktop":"https://cdn.shopify.com/videos/c/o/v/1c5ef7be6ae14ba6bbcf2ce97d54c384.mp4","mobile":"https://cdn.shopify.com/videos/c/o/v/1c5ef7be6ae14ba6bbcf2ce97d54c384.mp4","poster":"https://cdn.shopify.com/s/files/1/0844/7672/3453/files/vclot-campana-corregida-night-poster.jpg?v=1793141371"},"details":{"desktop":"https://cdn.shopify.com/videos/c/vp/6aa4841f9a6b477382da2da23850061f/6aa4841f9a6b477382da2da23850061f.HD-720p-1.6Mbps-98664907.mp4","mobile":"https://cdn.shopify.com/videos/c/vp/6aa4841f9a6b477382da2da23850061f/6aa4841f9a6b477382da2da23850061f.HD-720p-1.6Mbps-98664907.mp4","poster":"https://cdn.shopify.com/s/files/1/0844/7672/3453/files/vclot-studio-macro-poster.jpg?v=1792769945"}};
  const mobile = matchMedia('(max-width:749px)');
  const reduced = matchMedia('(prefers-reduced-motion:reduce)');
  const visible = new WeakSet();
  function play(video) {
    if (!reduced.matches && visible.has(video) && !document.hidden) video.play().catch(() => {});
    else video.pause();
  }
  const observer = new IntersectionObserver(entries => entries.forEach(({target,isIntersecting}) => {
    if(isIntersecting) visible.add(target); else visible.delete(target);
    play(target);
  }), {threshold:.05});
  function update() {
    const dark = document.documentElement.getAttribute('data-vclot-mode') === 'dark';
    document.querySelectorAll('[data-vclot-campaign]').forEach(video => {
      const film = video.dataset.vclotFilm === 'details' ? films.details : films[dark ? 'night' : 'day'];
      video.muted = true; video.autoplay = !reduced.matches; video.poster = mobile.matches ? (film.posterMobile || film.poster) : film.poster;
      const src = film[mobile.matches ? 'mobile' : 'desktop'];
      if (video.getAttribute('src') !== src) {
        video.src = src;
        video.addEventListener('loadedmetadata', () => play(video), {once:true});
      }
      if (!video.dataset.observed) { video.dataset.observed='true'; observer.observe(video); }
      play(video);
    });
    document.querySelectorAll('img[data-vclot-day-src]').forEach(img => {
      const src = dark ? img.dataset.vclotNightSrc : img.dataset.vclotDaySrc;
      if (src && img.getAttribute('src') !== src) {
        img.removeAttribute('srcset'); img.src = src;
        img.alt = dark ? img.dataset.vclotNightAlt : img.dataset.vclotDayAlt;
      }
    });
  }
  new MutationObserver(update).observe(document.documentElement,{attributes:true,attributeFilter:['data-vclot-mode']});
  mobile.addEventListener('change',update); reduced.addEventListener('change',update);
  document.addEventListener('visibilitychange',update);
  document.addEventListener('shopify:section:load',update);
  update();
})();
